import { useAskInputActions, useAskInputState, } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { useAskInputSuggestionPolicy } from '#pplx/frontend/apps/ask/suggest-dropdown/hooks/useAskInputSuggestionPolicy.js';
import { useSuggestDropdownKeyDown } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/hooks/useSuggestDropdownKeyDown.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useEffect, useMemo, useState } from 'react';
export const useSuggestDropdown = ({ autosuggestionsEnabled = true, inputQuery, inputJson, isInputActive, onChange, handleSuggestionSubmission, handleSuggestionView, querySource, hasThreadContent, isMentionMenuOpened, placement = 'bottom', inputRef, }) => {
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [userInputQuery, setUserInputQuery] = useState(inputQuery);
    const [userInputJson, setUserInputJson] = useState(inputJson);
    const { activeMenu, suggestions } = useAskInputState();
    const { setSuggestions, setShowSuggestDropdown } = useAskInputActions();
    const suggestionsDisabled = useAskInputSuggestionPolicy({
        autosuggestionsEnabled,
        hasThreadContent,
        inputQuery,
        querySource,
        suggestions,
    });
    const handleSuggestDropdownNavigation = useSuggestDropdownKeyDown({
        userInputQuery,
        userInputJson,
        suggestionsDisabled,
        suggestions,
        focusedIndex,
        setFocusedIndex,
        onChange,
        handleSuggestionSubmission,
        placement,
        inputRef,
    });
    useEffect(() => {
        if (focusedIndex === -1) {
            setUserInputQuery(inputQuery);
            setUserInputJson(inputJson);
        }
    }, [inputQuery, focusedIndex, inputJson]);
    useEffect(() => {
        if (suggestionsDisabled) {
            setSuggestions(EMPTY_ARRAY);
            setFocusedIndex(-1);
        }
    }, [suggestionsDisabled, setSuggestions, setFocusedIndex]);
    useEffect(() => {
        const showSuggestDropdown = !suggestionsDisabled &&
            // Show when the input is actively focused AND has been clicked at least once
            isInputActive &&
            // Hide when an input menu is open
            !activeMenu &&
            // Show when there are suggestions
            suggestions.length > 0 &&
            // Hide when mentions menu is open
            !isMentionMenuOpened;
        setShowSuggestDropdown(showSuggestDropdown);
        if (showSuggestDropdown) {
            handleSuggestionView(suggestions);
        }
    }, [
        suggestionsDisabled,
        isInputActive,
        activeMenu,
        suggestions,
        isMentionMenuOpened,
        setShowSuggestDropdown,
        handleSuggestionView,
    ]);
    return useMemo(() => ({
        focusedIndex,
        setFocusedIndex,
        suggestionsDisabled,
        userInputQuery,
        handleSuggestDropdownNavigation,
        placement,
    }), [focusedIndex, handleSuggestDropdownNavigation, suggestionsDisabled, userInputQuery, placement]);
};
//# sourceMappingURL=useSuggestDropdown.js.map